import {Form, Input, Select, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import DirectoryPicker from "../../../../../shared/pickers/file/DirectoryPicker";
import {IFilePickerWidgetType} from "../../../../../shared/pickers/file/FilePicker";

export interface IFieldFileOptions {
    fileWidget?: IFilePickerWidgetType
    fileCanChoose?: boolean
    fileCanUpload?: boolean
    fileCanDownload?: boolean
    fileCanRemove?: boolean
    fileMultiple?: boolean
    fileDisabled?: boolean
    fileDirectory?: number
    fileExtensions?: string[]
    fileModalPicker?: boolean
}

interface IProps extends IFieldOptionsEditorProps {

}

interface IState {
}

class FieldFileOptionsEditor extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    static getDefaultOptions(): IFieldFileOptions {
        return {
            fileCanChoose: true,
            fileCanDownload: false,
            fileCanRemove: false,
            fileCanUpload: true,
            fileWidget: 'simple'
        }
    }

    render() {
        const {buildFieldName} = this.props

        const types: { code: IFilePickerWidgetType, label: string }[] = [
            {code: "simple", label: 'Jednoduchý'},
            {code: "extended", label: 'Rozšířený'}
        ]

        const switches = [
            {label: 'Nahrání', code: 'fileCanUpload', initialValue: true},
            {label: 'Prohlížeč', code: 'fileCanChoose', initialValue: false},
            {label: 'Stahování', code: 'fileCanDownload', initialValue: false},
            {label: 'Odstranění', code: 'fileCanRemove', initialValue: false},
            {label: 'Nahrání modal', code: 'fileModalPicker', initialValue: false}
        ]

        return (
            <div>
                <Form.Item name={buildFieldName('fileWidget')} initialValue={'simple'}
                           label={'Vyberte režim výběru souborů'} rules={[{required: true}]}>
                    <Select>
                        {types.map(type => (
                            <Select.Option key={type.code} value={type.code}>{type.label}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label={'Možnosti'}>
                    <Input.Group>
                        {switches.map(switchItem => (
                            <Form.Item name={buildFieldName(switchItem.code)} initialValue={switchItem.initialValue}
                                       valuePropName={'checked'} noStyle>
                                <Switch className={'mr-2'}
                                        unCheckedChildren={switchItem.label}
                                        checkedChildren={switchItem.label}
                                />
                            </Form.Item>
                        ))}
                    </Input.Group>
                </Form.Item>
                <Form.Item name={buildFieldName('fileDirectory')} label={'Omezit na jednu složku'}>
                    <DirectoryPicker defaultRoot={false}/>
                </Form.Item>
            </div>
        )
    }
}


export default FieldFileOptionsEditor